export default "__VITE_ASSET__Dy7oT9wd__"